import React from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import AuthRedirect from "../../components/authRedirect";
import CabinetDepositNew from "../../components/cabinet/cabinetDepositNew";
import CabinetDepositOpenModal from "../../components/cabinet/cabinetDepositOpenModal";



const CabinetDepositPage = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container} ${Styles.cabinetPC}`}>
            <Seo title={t('Мои депозиты')}/>
            <AuthRedirect isCabinet={true}/>
            <div className={`${Styles.cabinetNote}`}>{t('Мои депозиты')}</div>
            <div className={`${Styles.posWrap}`}>
                <CabinetDepositNew/>
            </div>
            <CabinetDepositOpenModal/>
        </section>
    );
};

export default CabinetDepositPage;